'use strict';

import _, {get, isNil} from 'lodash';
import React, { PropTypes } from 'react';
import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import {lookup, getLookupValue, CONTACT_ROLES} from '../../../../../redux/helpers/staticData';
import * as employeesApi from '../../../../../redux/actionCreators/async/employees';

import StatusDropDown from '../../../../../common/components/StatusDropDown';
import EditIcon from '../../../../../common/svgs/EditIcon';
import DocumentIcon from '../../../../../common/svgs/DocumentIcon';
import JobRequestDocuments from '../Documents';
import EditJobRequestInformation from '../EditJobRequestInformation';
import io from 'socket.io-client';
import IconButton from 'material-ui/IconButton';
// utility function to turn dates to slashes
import prettyDate from '../../../../../lib/prettyDate';
import { JOB_REQUEST_STATUS } from './../../../../../common/enums';

const socket = io(process.env.BASE_URL);

const MODES = {
  empty: 0,
  view: 1,
  edit: 2
};

@connect((store) => {
  const contacts = store.companyContacts;
  const findContact = (profileId) => _.find(contacts, (contact) => contact.profile.id === profileId);
  const primaryContact = findContact(store.jobRequest.primaryContactId);

  return {
    staticData: store.staticData,
    jobRequest: store.jobRequest,
    contacts,
    primaryContact: primaryContact || store.contactProfile,
  };
})
export default class JobRequestDetails extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleUpdateStatus: PropTypes.func.isRequired,
    staticData: PropTypes.object.isRequired,
    jobRequest: PropTypes.object.isRequired,
    contacts: PropTypes.array.isRequired,
    contactProfile: PropTypes.object,

  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      mode: MODES.view,
      status: null,
      showDocuments: false,
    };
  }

  componentDidMount() {

      socket.on('status updated', (data) => console.log('e-mail from status changes:', data));

      const getUsersById  = (id) => this.props.dispatch(employeesApi.getUsersById(id));
      const findContact = (profileId) => _.find(this.props.contacts, (contact) => contact.profile.id === profileId);
      const contact = findContact(this.props.jobRequest.primaryContactId) || this.props.contactProfile;

      getUsersById(this.props.primaryContact.profile.clientAdvisorId)
        .then((clientAdvisor) => {

          if(this.props.primaryContact.profile.clientAdvisorId) {
            this.setState({clientAdvisorName: `${clientAdvisor.firstName} ${clientAdvisor.lastName}`});
          }

          return getUsersById(this.props.jobRequest.placementSpecialistId);
        })
        .then((placementSpecialist) => {

          if(this.props.jobRequest.placementSpecialistId) {
            this.setState({placementSpecialistName: `${placementSpecialist.firstName} ${placementSpecialist.lastName}`});
          }

          return getUsersById(this.props.primaryContact.company.relationshipManagerId);
        }).then((relationshipManager) => {

          if(this.props.primaryContact.company.relationshipManagerId) {
            this.setState({relationshipManagerName: `${relationshipManager.firstName} ${relationshipManager.lastName}`});
          }

        });
  }

  componentWillReceiveProps(nextProps) {

    const getUsersById  = (id) => this.props.dispatch(employeesApi.getUsersById(id));

    if(this.props.jobRequest.placementSpecialistId !== nextProps.jobRequest.placementSpecialistId) {

      getUsersById(this.props.primaryContact.profile.clientAdvisorId)
        .then((clientAdvisor) => {

          if(this.props.primaryContact.profile.clientAdvisorId) {
            this.setState({clientAdvisorName: `${clientAdvisor.firstName} ${clientAdvisor.lastName}`});
          }

          return getUsersById(this.props.jobRequest.placementSpecialistId);
        })
        .then((placementSpecialist) => {

          if(this.props.jobRequest.placementSpecialistId) {
            this.setState({placementSpecialistName: `${placementSpecialist.firstName} ${placementSpecialist.lastName}`});
          }

          return getUsersById(this.props.primaryContact.company.relationshipManagerId);
        }).then((relationshipManager) => {

          if(this.props.primaryContact.company.relationshipManagerId) {
            this.setState({relationshipManagerName: `${relationshipManager.firstName} ${relationshipManager.lastName}`});
          }

      });

   }

  }

  componentWillUnmount() {
    socket.disconnect();
  }


  switchModes(mode = MODES.view) {
    this.setState(...this.state, { mode });
  }

  handleEdit = () => this.switchModes(MODES.edit);

  handleClose = () => this.switchModes();

  handleChange = (event, value) => {

    const jobrequest = {
      id: this.props.jobRequest.id,
      primaryContactId: this.props.jobRequest.primaryContactId,
      jobRequestStatus: value,
    };

    this.props.handleUpdateStatus({jobrequest});
  }

  showDocuments = () => {
    this.setState({showDocuments: true});
  }

  closeDocuments = () => {
    this.setState({showDocuments: false});
  }

  renderView() {
    const jobRequest = this.props.jobRequest;

    const contact = this.props.primaryContact;
    const status = getLookupValue(this.props.staticData, 'jobRequestStatus', {id: jobRequest.jobRequestStatus});

    const priorityReasonId = get(jobRequest, 'priorityReason');
    const priorityReason =  _.find(this.props.staticData.jobRequestPriorityReasonTypes, {id: priorityReasonId});

    const priorityId = get(jobRequest, 'priority');
    const priority =  _.find(this.props.staticData.priorityTypes, {id: priorityId});

    const findContact = (profileId) => _.find(this.props.contacts, (contact) => contact.profile.id === profileId);
    const reportingContact = findContact(jobRequest.reportingContactId);
    const trainingContact = findContact(jobRequest.trainingContactId);
    const technologyContact = findContact(jobRequest.technologyContactId) || _.find(this.props.contacts, (contact) => _.indexOf(contact.profile.types, CONTACT_ROLES.TECHNOLOGY) >= 0 );
    const billingContact = findContact(jobRequest.billingContactId) || _.find(this.props.contacts, (contact) => _.indexOf(contact.profile.types, CONTACT_ROLES.BILLING) >= 0 );


    return (
      <div className='job-request-worksheet-details'>
        <div>
          <h1>{lookup(this.props.staticData, 'positionTypes', {id: jobRequest.positionTypeId})}</h1>
        </div>
        <div className='cols'>
          <div className='col1'>
            <div>ID# {jobRequest.id}</div>
            <div>Priority: { get(priority, 'name', 'None') }</div>
            <div>{ get(priorityReason, 'name', 'None') }</div>
          </div>
           <div className='col2'>
            <div>Client Advisor: {get(this.state, 'clientAdvisorName', 'None')}</div>
            <div>Placement Specialist: {get(this.state, 'placementSpecialistName', 'None')}</div>
            <div>Relationship Manager: {get(this.state, 'relationshipManagerName', 'None')}</div>
          </div>
          <div className='col2'>
            <div>Company:  <span className='hover-link' onClick={() => this.props.dispatch(push(`/admin/companies/${contact.company.id}/details`))}>{contact.company.name}</span></div>
            <div>Contact: <span className='hover-link' onClick={() => this.props.dispatch(push(`/admin/contacts/${contact.profile.id}/details`))}>{contact.user.firstName} {contact.user.lastName}</span></div>
            <div>Reporting Contact: {`${get(reportingContact, 'user.firstName', 'None')} ${get(reportingContact, 'user.lastName', '')}`}</div>
          </div>

          <div className='col2'>
            <div>Technology Contact: {technologyContact ?
              <span className='hover-link' onClick={() => this.props.dispatch(push(`/admin/contacts/${technologyContact.profile.id}/details`))}>
                {`${technologyContact.user.firstName} ${technologyContact.user.lastName}`}
              </span>
              : 'None'}
            </div>
            <div>Training Contact: {`${get(trainingContact, 'user.firstName', 'None')} ${get(trainingContact, 'user.lastName', '')}`}</div>
            <div>Billing Contact: {billingContact ?
              <span className='hover-link' onClick={(e) => this.props.dispatch(push(`/admin/contacts/${billingContact.profile.id}/details`))}>
                {`${billingContact.user.firstName} ${billingContact.user.lastName}`}
              </span>
              : 'None'}
            </div>
          </div>
          <div className='col2'>
            <div>Date Created: {(jobRequest.dateCreated ? prettyDate(jobRequest.dateCreated) : 'None')}</div>
            <div>Date Signed: {(jobRequest.dateAuthorized ? prettyDate(jobRequest.dateAuthorized) : 'None')}</div>
            <div>Date Approved: {(jobRequest.dateApproved ? prettyDate(jobRequest.dateApproved): 'None')}</div>
          </div>
        </div>
        <div className='actions'>
          <div className='job-status'>
            <StatusDropDown
              status={status}
              menuItems={this.props.staticData.jobRequestStatus}
              onChange={this.handleChange}
            />
          </div>
          <ul className='buttons'>
            <li >
              <IconButton style={{width: 'auto', padding: '0', border: '0'}} data-id='document icon' onClick={this.showDocuments} tooltip='Documents' tooltipPosition='bottom-center'>
                <DocumentIcon />
              </IconButton>
            </li>
            <li >
              <IconButton style={{width: 'auto', padding: '0', border: '0'}}  data-id='edit icon' onClick={this.handleEdit} tooltip='Edit' tooltipPosition='bottom-center'>
                <EditIcon />
              </IconButton>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  renderEdit() {
    return (
      <div></div>
    );
  }

  render() {

    return (
      <div>
        <div className='job-request-worksheeet-details-wrapper'>
        {
          (this.state.mode === MODES.view)
            &&
          this.renderView()
            ||
          (this.state.mode === MODES.edit)
            &&
          this.renderEdit()
        }
        </div>
        { this.state.showDocuments &&  <JobRequestDocuments closeDocuments={this.closeDocuments} /> }
        { this.state.mode === MODES.edit &&  <EditJobRequestInformation handleSave={this.props.handleSave} handleDelete={this.props.handleDelete} close={() => this.switchModes() } /> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/Details/index.js